<div class="wrapper">
    <app-header></app-header>
    <router-outlet></router-outlet>
<!--     <app-footer></app-footer> -->
     <toolkit-footer></toolkit-footer>

</div>
